// @ts-nocheck
import React, { useEffect, useState, useRef } from "react";
import { Helmet } from "react-helmet-async";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../../../backend/firebaseConfig";

function DflipBrochurePage() {
  const [pdfUrl, setPdfUrl] = useState(null);
  const timerRef = useRef(null);

  // 1) Fetch brochure URL from Firestore
  useEffect(() => {
    let cancelled = false;

    async function loadBrochure() {
      try {
        const ref = doc(db, "Marketing", "Website");
        const snap = await getDoc(ref);

        if (!cancelled && snap.exists()) {
          const url = (snap.data()?.rosemountBrochure || "").toString().trim();
          if (url) setPdfUrl(url);
        }
      } catch (err) {
        console.error("Failed to fetch brochure URL", err);
      }
    }

    loadBrochure();

    return () => {
      cancelled = true;
    };
  }, []);

  // 2) Init dFlip AFTER pdfUrl exists
  useEffect(() => {
    if (!pdfUrl) return;

    let cancelled = false;
    let tries = 0;

    const init = () => {
      if (cancelled) return;
      tries++;

      // clear any previous injected markup (prevents weird re-init bugs)
      const el = document.getElementById("brochure-flipbook");
      if (el) el.innerHTML = "";

      if (window.DFLIP && typeof window.DFLIP.parseBooks === "function") {
        window.DFLIP.parseBooks();

        requestAnimationFrame(() => {
          window.dispatchEvent(new Event("resize"));
        });
        return;
      }

      if (tries < 30) {
        timerRef.current = window.setTimeout(init, 100);
      } else {
        window.location.href = pdfUrl; // fallback
      }
    };

    init();

    return () => {
      cancelled = true;
      if (timerRef.current) window.clearTimeout(timerRef.current);
    };
  }, [pdfUrl]);

  return (
    <div style={{ minHeight: "100vh", width: "100%", overflow: "hidden" }}>
      <Helmet>
        <title>Rosemount Brochure</title>
      </Helmet>

      {pdfUrl && (
        <div
          id="brochure-flipbook"
          className="_df_book"
          data-source={pdfUrl}
          style={{ height: "100vh", width: "100%" }}
        />
      )}
    </div>
  );
}

export default DflipBrochurePage;
